import { LOGIN_NAME } from '@/router/constant';

/**
 * layout布局之外的路由
 * 如登录页、大屏页、toC门户页等需要单独展示，不需要嵌套到后台管理框架的页面
 * 如果不需要验证token权限，请到constant.js中白名单name
 */
export const outsideLayoutRoutes = [
  {
    path: '/',
    name: LOGIN_NAME,
    component: () => import(/* webpackChunkName: "login" */ '@/views/login/index.vue'),
    meta: {
      title: '登录'
    }
  }
];
